import { render, staticRenderFns } from "./AdminInvestorReport.pug?vue&type=template&id=d6cde84c&external"
import script from "./AdminInvestorReport.js?vue&type=script&lang=js&external"
export * from "./AdminInvestorReport.js?vue&type=script&lang=js&external"
import style0 from "./AdminInvestorReport.vue?vue&type=style&index=0&id=d6cde84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports